import React, { useState } from 'react';
import { useSelector } from 'react-redux';

import { SephoraView, SephoraViewContext } from 'types/sephora';
import { selectIsCustomer } from 'selectors/cookies';
import { selectIsLoadingLoyalty, selectIsValidated, selectLoyaltyId } from 'selectors/sephora';
import BeautyInsider from 'components/sephora/BeautyInsider';

export const SephoraContext = React.createContext<SephoraViewContext>({
  view: 'accountInfo',
  setView: () => {},
  sephoraEmail: '',
  setSephoraEmail: () => {}
});

export interface SephoraWrapperProps {
  isAccountOverview?: boolean;
}

const SephoraWrapper = ({ isAccountOverview }: SephoraWrapperProps) => {
  const [view, setView] = useState<SephoraView>('accountInfo');
  const [email, setEmail] = useState('');

  const isLoading = useSelector(selectIsLoadingLoyalty);
  const isZapposCustomer = useSelector(selectIsCustomer);
  const isSephoraCustomer = !!useSelector(selectLoyaltyId);
  const isVerified = useSelector(selectIsValidated);

  return (
    <SephoraContext.Provider value={{ view, setView, sephoraEmail: email, setSephoraEmail: setEmail }}>
      <BeautyInsider
        isLoading={isLoading}
        isZapposCustomer={isZapposCustomer}
        isSephoraCustomer={isSephoraCustomer}
        isVerified={isVerified}
        isAccountOverview={isAccountOverview}
      />
    </SephoraContext.Provider>
  );
};

export default SephoraWrapper;
